export default function decodeHTMLEntities(str: string): string {
  return str.replace(/&#(\d+);/g, function (_, dec) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return String.fromCharCode(dec);
  });
}
